export default __webpack_public_path__ + "static/media/img-0281-malta-half-face.5f64efeb.png";